export default "__VITE_ASSET__DfCsuung__"